<div class="w-100 view-item text-center">
    <p>Evolution mensuelle des ventes de pizzas depuis le début de l'installation.</p>
</div>
<div class="statview chart-wrapper">
    <canvas id="monthlychart" baseChart [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
        [colors]="lineChartColors" [legend]="lineChartLegend" [chartType]="lineChartType" [plugins]="lineChartPlugins">
    </canvas>
</div>
